import type ConversationAssistant from '@atlassian/conversation-assistant';
import type { ConversationAction } from '@atlassian/rovo-conversation-actions';
import { ConversationActionTags } from '@atlassian/rovo-conversation-actions/types';

export type RovoAction = {
	action: ConversationAction;
};

export type RovoConfiguration = {
	getActions: React.ComponentProps<typeof ConversationAssistant>['getActions'];
	tags?: ConversationActionTags;
	nudges?: ConversationAction[];
};

export interface RovoConfigurationProviderProps {
	setConfiguration: (config: RovoConfiguration) => void;
}

export enum RegisteredExperience {
	VIEW_PAGE = 'view-page',
	EDIT_PAGE = 'edit-page',
	WHITEBOARD = 'whiteboard',
}

export type RegisteredExperienceType = RegisteredExperience;

export type RovoProviderComponent = React.ComponentType<any>;

export type RovoConfigProviderBaseProps = {
	experience?: RegisteredExperienceType;
	provider?: RovoProviderComponent;
};

export type CommonRovoConfigProviderProps = {
	contentId: string;
	spaceKey: string;
	contentTitle: string;
};

export type PageRovoConfigProviderProps = RovoConfigProviderBaseProps &
	CommonRovoConfigProviderProps & {
		contentType: string;
		lastModifiedDate?: string | null;
		isUnpublishedDraft?: boolean;
		readTime?: number;
		readTimeLoading?: boolean;
	};

export type WhiteboardRovoConfigProviderProps = RovoConfigProviderBaseProps &
	CommonRovoConfigProviderProps & {
		actionsToRender: ConversationAction[];
	};

export type RovoConfigProviderProps =
	| PageRovoConfigProviderProps
	| WhiteboardRovoConfigProviderProps;

export const isWhiteboardRovoConfigProviderProps = (
	props: RovoConfigProviderProps,
): props is WhiteboardRovoConfigProviderProps => 'actionsToRender' in props;

export const isPageRovoConfigProviderProps = (
	props: RovoConfigProviderProps,
): props is PageRovoConfigProviderProps => 'contentType' in props;
